import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function Navbar() {
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  const initials = profile?.full_name
    ?.split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', minWidth: 0, flex: 1 }}
          onClick={() => navigate(profile?.role === 'clinician' ? '/clinician' : '/patient')}>
          {profile?.clinics?.logo_url ? (
            <img
              src={profile.clinics.logo_url}
              alt={profile.clinics.name}
              style={{ height: 36, width: 'auto', maxWidth: 120, objectFit: 'contain', flexShrink: 0 }}
            />
          ) : (
            <span style={{ fontWeight: 800, fontSize: 18, color: '#6366f1', letterSpacing: -0.5, whiteSpace: 'nowrap' }}>
              Complete PT
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
          {profile?.role === 'patient' && (
            <button onClick={() => navigate('/patient/settings')} style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '6px 8px', borderRadius: 8, color: 'var(--text-secondary)', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
              Account
            </button>
          )}
          {profile?.role === 'clinician' && (
            <button onClick={() => navigate('/clinician/settings')} style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '6px 8px', borderRadius: 8, color: 'var(--text-secondary)', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
              Settings
            </button>
          )}
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#eef2ff', color: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 11, flexShrink: 0 }}>{initials}</div>
          <button onClick={handleSignOut} style={{ background: 'white', color: '#111827', border: '1.5px solid #e5e7eb', borderRadius: 8, padding: '5px 8px', fontSize: 12, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap', fontFamily: 'inherit' }}>
            Sign out
          </button>
        </div>
      </div>
    </nav>
  )
}